import React from 'react'
import { BooleanInput, Edit, SimpleForm } from 'react-admin'
import AutocompleteReferenceInput from '../AutocompleteReferenceInput'
import ServiceTypeInput from '../common/ServiceTypeInput'
import VehicleTypeInput from '../common/VehicleTypeInput'

const FleetServiceEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <AutocompleteReferenceInput
        source='fleet_id'
        reference='fleet'
        optionText='name'
        label='Fleet'
      />
      <BooleanInput source='multi_drop_supported' />
      <ServiceTypeInput source='service_type' />
      <VehicleTypeInput source='vehicle_type' />
    </SimpleForm>
  </Edit>
)

export default FleetServiceEdit
